// extracted by mini-css-extract-plugin
export default {"container":"UTYi30"};